export default __webpack_public_path__ + "static/media/LucasLejeune.62656dd1.webp";